<template>
    <div class="input-item">
        <label v-if="label" class="input-item__label">{{ label }}</label>

        <select
            v-bind="{
                ...$attrs,
                onChange: ($event) => { $emit('update:modelValue', handleInputChange($event)) }
            }"
            class="input-item__select"
            placeholder="Välj"
            :value="modelValue"
            :class="{
                'input-item--error': vMessage.length > 0,
                'input-item__select--b-none': border === 'none'
            }"
        >
            <option class="selecter__option" value="0" selected>{{ $t('choose')}}</option>
            <option
                v-for="(option, index) in options"
                class="selecter__option"
                :key="index"
                :value="option.value"
                :selected="option.value === modelValue"
            >
                {{ option.name }}
            </option>
        </select>

        <span class="v input-item__error" v-if="vMessage.length > 0">
            <span class="v--error input-item__error__msg">{{ vMessage[0] }}</span>
        </span>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue'

    interface ISelectProp {
        id?: number,
        name: string,
        value: any
    }

    export default defineComponent({
        props: {
            label: {
                type: String,
                default: ''
            },
            modelValue: {
                type: [Number, String],
                default: ''
            },
            options: {
                type: Object as PropType<ISelectProp[]>,
                required: true
            },
            border: {
                type: String,
                default: 'default'
            },
            vMessage: {
                type: Array,
                default: []
            }
        },
        setup() {
            const handleInputChange = (event: Event) => (event.target as HTMLInputElement).value

            return {
                handleInputChange
            }
        }
    })
</script>
